import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { ReportTypes } from "../../../reports/models/reports";
import { MoneyCardsResponse } from "../../../_models";

@Injectable({
  providedIn: "root",
})
export class OverviewOrderMoneyCardsService extends DashboardService {
  route = "order_dashboard/money_cards";
  protected reportType = ReportTypes.ORDER_RETENTION;
  protected data: BehaviorSubject<MoneyCardsResponse> = new BehaviorSubject<MoneyCardsResponse>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }
}
